import { forwardRef, Ref } from 'react';
import { Checkbox as MUICheckbox, Grid } from '@mui/material';
import {
  AB3, S2, S3, S4,
} from '../../../theme';
import { ICheckboxProps } from '../index';
import { mergeSX } from '../../../services/helpers';
import { UnselectedCheckbox, SelectedCheckbox, IndeterminateCheckbox } from '../../../icons';
import { CheckboxSizeEnum } from '../../../enums';

export const CHECKBOX_ICONS_SIZE = {
  small: {
    height: 16,
    width: 16,
  },
  medium: {
    height: 18,
    width: 18,
  },
};

const buildSX = () => ({
  color: S4,
  padding: 1,
  '&:hover': {
    backgroundColor: S2,
  },
  '&.Mui-disabled': {
    color: S3,
  },
  '&.MuiCheckbox-indeterminate': {
    color: AB3,
  },
  '&.Mui-checked': {
    color: AB3,
    '&.Mui-disabled': {
      color: S3,
    },
  },
});

const Checkbox = forwardRef((props: ICheckboxProps, ref) => {
  const {
    label, sx, size = CheckboxSizeEnum.Medium, ...rest
  } = props;

  return (
    <Grid container alignItems="center">
      <MUICheckbox
        sx={mergeSX(buildSX(), sx)}
        size={size}
        inputRef={ref as Ref<HTMLInputElement>}
        icon={(<UnselectedCheckbox {...CHECKBOX_ICONS_SIZE[size]} />)}
        checkedIcon={(<SelectedCheckbox {...CHECKBOX_ICONS_SIZE[size]} />)}
        indeterminateIcon={(<IndeterminateCheckbox {...CHECKBOX_ICONS_SIZE[size]} />)}
        {...rest}
      />
      {label}
    </Grid>
  );
});

export default Checkbox;
